// extracted by mini-css-extract-plugin
export default {"butWithLegend":"ButtonsLayout_butWithLegend__dopXm","but":"ButtonsLayout_but__K2Upc","icon":"ButtonsLayout_icon__QbXEP"};